export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  s3: {
    BUCKET: "YOUR_S3_UPLOADS_BUCKET_NAME",
  },
  // Live
  apiGateway: {
    REGION: process.env.REACT_APP_REGION_CMS,
    URL: process.env.REACT_APP_URL,
    baseUrl: process.env.REACT_APP_BASEURL,
  },
  // Local
  // apiGateway: {
  //   REGION: process.env.REACT_APP_REGION_CMS,
  //   URL: process.env.REACT_APP_URL,
  //   baseUrl: process.env.REACT_APP_BASEURL,
  // },
};
